import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-modal-body',
  templateUrl: './custom-modal-body.component.html',
  styleUrls: ['./custom-modal-body.component.scss']
})
export class CustomModalBodyComponent {

}
